import { render, staticRenderFns } from "./YoWhatsApp.vue?vue&type=template&id=740a28d5&scoped=true"
import script from "./YoWhatsApp.vue?vue&type=script&lang=js"
export * from "./YoWhatsApp.vue?vue&type=script&lang=js"
import style0 from "./YoWhatsApp.vue?vue&type=style&index=0&id=740a28d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740a28d5",
  null
  
)

export default component.exports